import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LogoLight } from './Logo';

export default function Sidebar() {
  const { user, isAdmin, logout } = useAuth();

  const navItems = [
    { to: '/dashboard', icon: 'ti-dashboard', label: 'Dashboard' },
    { to: '/inventory', icon: 'ti-package', label: 'Inventory' },
    ...(isAdmin ? [{ to: '/products', icon: 'ti-tag', label: 'Products' }] : []),
    { to: '/billing', icon: 'ti-receipt', label: 'New Invoice' },
    { to: '/invoices', icon: 'ti-file-invoice', label: 'Invoices' },
    ...(isAdmin ? [{ to: '/users', icon: 'ti-users', label: 'Users' }] : []),
    { to: '/reports', icon: 'ti-chart-bar', label: 'Reports' },
    ...(isAdmin ? [{ to: '/purchases', icon: 'ti-shopping-bag', label: 'Purchases' }] : []),
    ...(isAdmin ? [{ to: '/settings', icon: 'ti-settings', label: 'Settings' }] : []),
  ];

  return (
    <div className="sidebar">
      <div className="sidebar-logo">
        <div>
          <div className="logo-text">
            <LogoLight size={14} />
          </div>
          <div style={{ fontSize: 9, color: 'rgba(255,255,255,.4)', marginTop: 1 }}>
            Smart Shopping, Every Day
          </div>
        </div>
      </div>
      <div className="sidebar-user">
        <strong>{user?.name}</strong>
        <span className="role-badge">{isAdmin ? 'Admin' : 'Staff'}</span>
      </div>
      <nav className="sidebar-nav">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
          >
            <i className={`ti ${item.icon}`} aria-hidden="true"></i>
            {item.label}
          </NavLink>
        ))}
      </nav>
      <div className="sidebar-footer">
        <button className="logout-btn" onClick={logout}>
          <i className="ti ti-logout" aria-hidden="true"></i>
          Sign out
        </button>
      </div>
    </div>
  );
}
